<template>
  <div class="page-title">{{title}}</div>
</template>

<script>
export default {
  name: 'page-title',
  props: ['title']
}
</script>

<style lang="stylus" scoped>
@import '~@/common/stylus/variables'
@import '~@/common/stylus/main'
.page-title {
  color $color-black
  font-family Aspira Demi
  font-size 44px
  padding 46px 40px
  font-weight: 500
}
</style>
